import { NavItem } from "../../../components/nav/item";
import { NavSubItem } from "../../../components/nav/sub-item";
import { WORK } from "icons";

export function WorkNavigations() {
  return (
    <NavItem
      title="Work"
      icon={WORK}
      url="/work"
      matchExact={true}
      defaultOpen={true}
    >
      <NavSubItem title="Projects" url="/work/projects" />
      <NavSubItem
        title="Contracts"
        url="/work/contracts"
        requiredPermissions={{
          type: "collection",
          collection: "contracts",
        }}
      />
      <NavSubItem title="Jobs" url="/work/jobs" />
      <NavSubItem
        title="Billables"
        url="/work/billables"
        requiredPermissions={{
          type: "collection",
          collection: "billables",
        }}
      />
      <NavSubItem title="Milestones" url="/work/milestones" requiredPermissions={{
        type: "collection",
        collection: "milestones",
      }} />
    </NavItem>
  );
}
